import type { FC } from 'react';

import type { LinkProps } from 'react-router-dom';

import { NoTextDecorationLink } from './styles';

interface StyledLinkProps extends LinkProps {
  variant: 'noTextDecoration';
}

const variants = {
  noTextDecoration: NoTextDecorationLink,
};

export const StyledLink: FC<StyledLinkProps> = ({ variant, children, ...props }) => {
  const StyledLinkComponent = variants[variant];
  return <StyledLinkComponent {...props}>{children}</StyledLinkComponent>;
};
